module.exports = __webpack_public_path__ + "img/00.dcc03f5a.png";